import React from 'react';
import PropTypes from 'prop-types';
import PrismModal from '../prism/modal/prismModal';
import PrismButton from '../prism/button/prismButton';

class PrismSubmitModal extends React.PureComponent {
    static propTypes = {
        header: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.node
        ]),
        content: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.node
        ]),
        cancelText: PropTypes.string,
        submitText: PropTypes.string,
        submitDisabled: PropTypes.bool,
        onCancel: PropTypes.func.isRequired,
        onSubmit: PropTypes.func.isRequired,
        cancelDisabled: PropTypes.bool,
        className: PropTypes.string
    };

    static defaultProps = {
        content: 'Are you sure you want to continue?',
        cancelText: 'Cancel',
        submitText: 'Submit'
    }

    renderModalContent = ({ content }) => typeof(content) === 'string'
        ? <p>{content}</p>
        : content;

    renderModalButtons = ({
        cancelText,
        submitText,
        submitDisabled,
        onCancel,
        onSubmit,
        cancelDisabled
    }) => (
        <>
            <PrismButton
                className="prism-submit-modal__action-button"
                type="button"
                textonly
                onClick={onCancel}
                disabled={cancelDisabled}
            >
                {cancelText}
            </PrismButton>
            <PrismButton
                className="prism-submit-modal__action-button"
                type="button"
                outline
                disabled={submitDisabled}
                onClick={onSubmit}
            >
                {submitText}
            </PrismButton>
        </>
    )

    render() {
        const {
            header,
            onCancel,
            className
        } = this.props;

        return (
            <PrismModal
                isOpen
                toggle={onCancel}
                headerTitle={header}
                className={className}
            >
                <div className='prism-submit-modal'>
                    <div className='prism-submit-modal__content-container'>
                        {this.renderModalContent(this.props)}
                    </div>
                    <div className='prism-submit-modal__action-buttons-container'>
                        {this.renderModalButtons(this.props)}
                    </div>
                </div>
            </PrismModal>
        );
    }
}

export default PrismSubmitModal;
